<template>
  <popup-warp v-model="isView">
    <div class="coupon-add-warp">
      <div class="coupon-add-mark"></div>
      <div class="coupon-add-title">{{ i18n.coupon_btn }}</div>
      <div class="coupon-add-input">
        <input type="text" v-model="code" :placeholder="i18n.code" />
      </div>
      <div class="btn" @click="getInvite">{{ i18n.add_promos }}</div>
    </div>
  </popup-warp>
</template>

<script>
import { PopupWarp } from "@/components/popup"
import { INVITE_CODE, COUPON_SEND } from "@/apis/user.js"
export default {
  props: {
    // 是否显示
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PopupWarp
  },
  computed: {
    i18n() {
      return this.$t("coupon")
    },
    msgI18n() {
      return this.$t("msg")
    },
    isView: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {
      code: ''
    }
  },
  methods: {
    onClose() {
      this.$emit('input', false)
    },
    getInvite() {
      this.$loading(true)
      this.$post(
        INVITE_CODE,
        {
          inviteCode: this.code
        },
        (resp) => {
          this.$loading(false)
          this.$toast(this.msgI18n.success)
          this.code = ''
          this.value = false
          this.$emit('refresh')
        },
        (error) => {
          console.log(error)
          this.sendCoupon()
        }
      )
    },
    sendCoupon() {
      this.$post(
        `${COUPON_SEND}?code=${this.code}`,
        {},
        (resp) => {
          this.$loading(false)
          this.$toast(this.msgI18n.success)
          this.code = ''
          this.value = false
          this.$emit('refresh')
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
.coupon-add-warp {
  background: #fff;
  border-radius: 50px 50px 0 0;
  padding: 20px 53px 80px;
  .coupon-add-mark {
    width: 150px;
    height: 8px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.1);
    margin: 0 auto;
  }
  .coupon-add-title {
    font-weight: 600;
    font-size: 36px;
    padding: 80px 0 44px;
  }
  .coupon-add-input {
    height: 100px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: #F8F6FC;
    border-radius: 20px;
    padding: 0 20px;
    margin-bottom: 80px;
    input {
      font-size: 32px;
      width: 300px;
      flex: 1;
      height: 80px;
      padding: 0 20px;
      margin: 0;
      border: none;
      outline: none;
      background-color: rgba(0, 0, 0, 0);
    }
  }
}
</style>
